import type { OptionsDocument, AnyPresentationOption } from 'paintscout'
import shuffle from 'lodash/shuffle'

export function getDefaultPresentationImages(args: { options: OptionsDocument; presentation: AnyPresentationOption }) {
  const { presentation } = args

  if (presentation.advanced.defaultImages && presentation.advanced.defaultImages.length > 0) {
    return shuffle(presentation.advanced.defaultImages)
  }

  return []
}
